import _ from 'lodash';
import React from 'react';
import AppLink from '../AppLink/AppLink';

interface IEmailLinkProps {
  email?: string;
}

export default function EmailLink({ email }: IEmailLinkProps) {
  if (_.isEmpty(email)) return null;

  return (
    <AppLink to={`mailto:${email}`}>{email}</AppLink>
  );
}
